import React from 'react';
import PropTypes from 'prop-types';

import {FormInput} from 'components/formInput';
import {Link} from 'components/link';
import {Button} from 'components/button';
import {Alert} from 'components/alert';
import {Header} from 'components/header';
import {LoadingIcon} from 'components/loadingIcon';
import AuthService from 'services/AuthService';
import {WithCommonTranslations} from 'components/hocs';
import {TranslationMixin} from 'mixins/translationMixin';
import {AlertMixin} from 'mixins/alertMixin';

import './LoginForm.css';

export const LoginForm = WithCommonTranslations(
    class extends AlertMixin(TranslationMixin(React.Component)) {
      constructor(props) {
        super(props);

        this.unmount = false;

        this.state = {
          verificationToken: null,
          verificationCode: '',
          isAuthenticating: false,
          loginId: '',
          loginPw: '',
          email: '',
          alert: {
            display: false,
            message: '',
          },
        };

        this.handleSendEmail = this.handleSendEmail.bind(this);
      }

      componentWillUnmount() {
        this.unmount = true;
      }

      validateForm() {
        let valid = this.state.loginId.length > 0 && this.state.loginPw.length >
            0;
        if (this.state.verificationToken) {
          valid = valid && this.state.verificationCode.length > 0;
        }
        return valid;
      }

      handleChange = event => {
        this.setState({[event.target.id]: event.target.value});
      };

      handleSubmit = async event => {
        event.preventDefault();

        this.setState({
          isAuthenticating: true,
          alert: {
            display: false,
            message: '',
          },
        });

        AuthService.login(this.state.loginId, this.state.loginPw,
            this.state.verificationToken, this.state.verificationCode,
            this.props.locale)
            .then(user => {
              Promise.resolve(this.props.onLoginSuccess(user)).then(() => {
                if (!this.unmount) {
                  this.setState({
                    isAuthenticating: false,
                  });
                }
              }).catch((error) => {
                if (!this.unmount) {
                  this.setState({
                    isAuthenticating: false,
                    alert: {
                      display: true,
                      message: error,
                    },
                  });
                }
              });

            })
            .catch(error => {
              if (error.code === '1005' && error.category ===
                  'AUTHENTICATION') {
                this.handleSendEmail();
              }

              this.props.onLoginFailure(error);

              this.displayError(error);
              this.setState({
                isAuthenticating: false,
              });
            });
      };

      handleSendEmail() {
        return AuthService.requestVerificationCode(this.state.loginId,
            this.state.email).then(data => {
          this.setState({
            verificationToken: data.verificationToken,
          });
        }).catch(e => {
          this.displayError(e);
        });
      }

      render() {
        const {onLinkClick, registrationLink, forgotPasswordLink, regionData} = this.props;
        const {verificationToken} = this.state;
        return (
            <div className="loginForm">
              <form onSubmit={this.handleSubmit}>
                <Header level={2}>{this.getTranslation(
                    'LABEL_LOGIN_OR_REGISTER')}</Header>

                {this.state.alert.display &&
                <Alert type={'error'}>
                  {this.state.alert.message}</Alert>}

                <FormInput id='loginId' name="login"
                           label={this.getTranslation('LABEL_LOGIN_NAME')}
                           autoFocus
                           value={this.state.loginId}
                           onChange={this.handleChange}/>
                <div className="tds-pw">
                  <FormInput id='loginPw' name="password"
                             type='password'
                             autoComplete="off"
                             label={this.getTranslation('LABEL_PASSWORD')}
                             value={this.state.loginPw}
                             onChange={this.handleChange}/>

                  {forgotPasswordLink &&
                  <Link to={forgotPasswordLink}
                        onClick={onLinkClick}>
                    {this.getTranslation('LABEL_FORGOT_PASSWORD')}</Link>}
                </div>

                {verificationToken &&
                <div>
                  <FormInput id='verificationCode' name="verificationCode"
                             required={true}
                             label={this.getTranslation(
                                 'LABEL_VERIFICATION_CODE')}
                             value={this.state.verificationCode}
                             onChange={this.handleChange}/>
                  <Button type="button" variant="link"
                          className="btn-send-code"
                          onClick={this.handleSendEmail}>
                    {this.getTranslation('LABEL_SEND_CODE')}
                  </Button>
                </div>
                }

                <Button type="submit"
                        variant="primary"
                        className="btn-login"
                        disabled={!this.validateForm() ||
                        this.state.isAuthenticating}>
                  <LoadingIcon display={this.state.isAuthenticating}/>
                  {this.getTranslation('BUTTON_LOGIN')}</Button>
                {regionData && regionData.regionCode !== 'CN' && registrationLink && <Link to={registrationLink}
                                           onClick={onLinkClick}>{this.getTranslation(
                    'LABEL_SIGN_UP')}</Link>}
              </form>
            </div>
        );
      }
    });

LoginForm.propTypes = {
  onLoginSuccess: PropTypes.func.isRequired,
  onLoginFailure: PropTypes.func.isRequired,
  registrationLink: PropTypes.string,
  forgotPasswordLink: PropTypes.string,
  onLinkClick: PropTypes.func,
};